import { useState } from 'react';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

/**
 * 精度確認モードの状態を管理するフック
 * セッションストレージに状態を保存
 */
export const useAccuracyCheckMode = () => {
  const [isAccuracyCheckMode, setIsAccuracyCheckMode] = useState<boolean>(() =>
    getSessionStorage('debug-accuracy-check-mode'),
  );

  const toggleAccuracyCheckMode = (checked: boolean) => {
    setIsAccuracyCheckMode(checked);
    setSessionStorage('debug-accuracy-check-mode', checked);
  };

  return {
    isAccuracyCheckMode,
    toggleAccuracyCheckMode,
  };
};
